import React, { useState, useRef, useContext } from "react";
import { Grid, Pagination } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";

import Bread from "../../common/Bread";
import AxiosClass from "../../common/AxiosClass";
import { LangContext } from "../../context/LangContext";
import Loader from "../../common/Loader";

import cover from "../../assets/notice.png";

const NoticeList = () => {
  const [isPage, setIsPage] = useState(1);
  const items = useRef([]);

  const lang = useContext(LangContext);
  const nep = lang.state.np;

  const location = useLocation();

  // Detect page type
  const type = location.pathname.includes("right-to-information")
    ? "right_to_information"
    : "notice";

  // API Call
  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["noticesData", isPage, type],
    queryFn: async () => {
      const res = await AxiosClass.getApi(`/notices/all/${type}/${isPage}`);
      return res.data;
    },
    keepPreviousData: true,
  });

  // Loading
  if (isLoading || isFetching) return <Loader />;

  // Error
  if (error) {
    return <div>An error has occurred: {error.message}</div>;
  }

  // No data safety
  if (!data || !data.items) {
    return <div>No data found.</div>;
  }

  // Set Items
  items.current = nep ? data.items.np : data.items.en;

  // Breadcrumb
  const breadcrumList = {
    image: "",
    link:
      type === "right_to_information" ? "/right-to-information" : "/notices",

    title:
      type === "right_to_information"
        ? nep
          ? "सूचनाको हक"
          : "Right To Information"
        : nep
          ? "सबै न्युज"
          : "Notices",

    l1: nep ? "होम" : "Home",

    l2:
      type === "right_to_information"
        ? nep
          ? "सूचनाको हक"
          : "Right To Information"
        : nep
          ? "न्युज"
          : "Notices",

    l3: "",
  };

  return (
    <>
      <Bread data={breadcrumList}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {items.current?.map((item, index) => (
            <Grid item xs={12} sm={4} md={4} key={index}>
              <div className="box-item-news">
                {/* Image */}
                <div className="img-news">
                  <a
                    href={`/${
                      type === "right_to_information"
                        ? "right-to-information"
                        : "notices"
                    }/${item.slug}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={cover} alt={item.slug} />
                  </a>
                </div>

                {/* Content */}
                <div className="content-news">
                  {/* Publish Date */}
                  {type === "right_to_information" && item.publish_date && (
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#777",
                        marginBottom: "10px",
                      }}
                    >
                      {nep ? "प्रकाशित मिति :" : "Publish Date :"}{" "}
                      {item.publish_date}
                    </p>
                  )}

                  {/* Title */}
                  <h1 style={{ fontSize: "20px" }}>
                    <a
                      href={`/${
                        type === "right_to_information"
                          ? "right-to-information"
                          : "notices"
                      }/${item.slug}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        textDecoration: "none",
                        color: "#000",
                      }}
                    >
                      {item.Title?.substring(0, 100)}
                    </a>
                  </h1>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>

        {/* Pagination */}
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={12}>
            {data?.total > data?.per_page && (
              <Pagination
                style={{ marginTop: "24px" }}
                className="paginationContainer"
                count={Math.ceil(data.total / data.per_page)}
                color="primary"
                size="large"
                page={isPage}
                onChange={(e, value) => {
                  setIsPage(value);
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }}
              />
            )}
          </Grid>
        </Grid>
      </Bread>
    </>
  );
};

export default NoticeList;
